import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import {
  DoctorStationObservationListResponse,
  DoctorStationObservation
} from '@/Network/Types/Responses/DsObservationResponse'

export default class ObservationService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/doctor-stations-observation'
  }

  async list(doctorStationId: number): Promise<DoctorStationObservationListResponse> {
    try {
      const { data } = await request.get<DoctorStationObservationListResponse>(
        `${this.getCompletePath()}/list/${doctorStationId}`
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as observações')
    }
  }

  async create(
    doctorStationId: number,
    observation: { text: string; scheduleId: number }
  ): Promise<DoctorStationObservation> {
    try {
      const { data } = await request.post<DoctorStationObservation>(
        `${this.getCompletePath()}/${doctorStationId}`,
        observation
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível criar a observação')
    }
  }

  async delete(id: number, scheduleId: number, observationAuthorId: number): Promise<void> {
    try {
      await request.delete(
        `${this.getCompletePath()}/${id}/schedule/${scheduleId}/author/${observationAuthorId}`
      )
    } catch (e) {
      throw this.handleError(e, 'Não foi possível excluir a observação')
    }
  }
}
